const l10nErrors = {
  'validation.required':    'Обязательное поле',
  'validation.email':       'Некорректный email',
  'validation.email_taken': 'Данный email уже существует в системе',
  'validation.unique':      'Данный email уже существует в системе',
  'validation.min.string':  'Минимальная длина пароля 6 символов',
  'validation.confirmed':   'Пароли не совпадают',
  'validation.phone':       'Некорректный телефон',
  'validation.length':      'Некорректный телефон',
  'login_failed':           'Неверные Email/Пароль',
  'not_found':              'Email не найден',
  'network_error':          'Ошибка сети',
  'unknown_error':          'Неизвестная ошибка',
};

const l10nError = ( error ) => l10nErrors[error] || error;

const flat = ( error ) => Array.isArray(error) ? error.map(l10nError).join(', ') : l10nError(error);

export default function mergeCommonErrors(
  errors,
  ignoreKeys = [],
) {
  if (typeof errors === 'string') return { common: errors };
  const finalErrors = {};
  const commonErrors = [];
  for (let key in errors) {
    const value = errors[key];
    if (ignoreKeys.includes(key)) {
      finalErrors[key] = flat(value);
    } else {
      if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++) {
          commonErrors.push(flat(value[i]));
        }
      } else {
        commonErrors.push(flat(value));
      }
    }
  }
  if (commonErrors.length) finalErrors.common = flat(commonErrors);
  return finalErrors;
}

export const getCommonError = ( errors ) => {
  return mergeCommonErrors(errors).common.toString();
};
